import { createContext, useState, ReactNode } from 'react';

export interface ThemeModeContextProps {
  mode: 'light' | 'dark';
  toggleTheme: () => void;
  setMode: (mode: 'light' | 'dark') => void;
}

export const ThemeModeContext = createContext<ThemeModeContextProps>({
  mode: 'light',
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  toggleTheme: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setMode: () => {}
});

export const ThemeModeProvider = ({ children }: { children: ReactNode }) => {
  const [mode, setModeState] = useState<'light' | 'dark'>(() => {
    const stored = localStorage.getItem('themeMode');
    return stored === 'dark' || stored === 'light' ? stored : 'light';
  });

  const toggleTheme = () => {
    setModeState((prev) => {
      const newMode = prev === 'light' ? 'dark' : 'light';
      localStorage.setItem('themeMode', newMode);
      return newMode;
    });
  };

  const setMode = (newMode: 'light' | 'dark') => {
    localStorage.setItem('themeMode', newMode);
    setModeState(newMode);
  };

  return (
    <ThemeModeContext.Provider value={{ mode, toggleTheme, setMode }}>
      {children}
    </ThemeModeContext.Provider>
  );
};
